//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        coffees: {
            required: true,
            type: Array,
        },
        contactUrl: {
            required: true,
            type: String,
        }
    },

    mounted() {
        window.dataLayer?.push( { 'event': 'step6in' } );
    }
}
